// Routing
export const ROUTE_HOME = "/";
export const SUBROUTE_MAGIC_LINK = "sign-in-token";
export const SUBROUTE_SIGN_IN = "sign-in";
export const SUBROUTE_SIGN_IN_SECOND_STEP = "sign-in/:option";
export const SUBROUTE_PATIENTS = "patients";
export const SUBROUTE_PATIENTS_ADMIN = "admin";
export const SUBROUTE_PATIENTS_DETAIL = "patients/:patient";

export const SUBROUTE_HOME_SECTION = "sections/:title/";
export const SUBROUTE_HOME_SECTION_DOCUMENTS = "documents";
export const SUBROUTE_HOME_SECTION_ACUTY_CALENDAR = "monthly-training";
export const SUBROUTE_HOME_SECTION_VIDEOS = "videos";
export const SUBROUTE_CLINIC_HOME = "clinic-dashboard";
export const SUBROUTE_CLINIC_WEIGHT_HOME = "clinic-weight-dashboard";
export const SUBROUTE_CLINIC_PATIENTS = "clinic-dashboard/patients";

export const SUBROUTE_CLINIC_WEIGHT = "/patients-clinic-weight";

export const SUBROUTE_CLINIC_HOME_STUDOQ = "clinic-dashboard/studoq";
export const SUBROUTE_STUDOQ_TEST = "clinic-dashboard/studoq/:id";

// Error messages
export const ERROR_MESSAGE_GENERIC =
  "Etwas ist schiefgelaufen. Bitte versuche es erneut.";
export const ERROR_MESSAGE_USER_NOT_FOUND =
  "Es konnte kein Nutzer mit dieser Email/Telefonnummer gefunden werden.";

export const TYPEFORM_ANAMNESEBOGEN_ID = "oLfjZqYg";
